import React, { useEffect, useState } from "react";

//MUI
import styled from "@emotion/styled";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';

//icons
import { ReactComponent as PrevIcon } from "../../assets/prev_icon.svg";
import { ReactComponent as NextIcon } from "../../assets/next_icon.svg";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  background: "transparent",
  display: "flex",
  justifyContent: "center",
  "& .prev_btn_container": {
    width: "20%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingLeft: "1rem",
    [theme.breakpoints.down("xl")]: {
      width: "13%",
    },
    [theme.breakpoints.down("lg")]: {
      width: "10%",
      paddingLeft: "0.2rem",
    },
    "& .btn_style": {
      height: "60px",
      [theme.breakpoints.down("xl")]: {
        height: "48px",
      },
      [theme.breakpoints.down("lg")]: {
        height: "42px",
      },
      "& svg": {
        width: "30px",
        height: "50px",
        [theme.breakpoints.down("xl")]: {
          width: "28px",
          height: "40px",
        },
        [theme.breakpoints.down("lg")]: {
          width: "28px",
          height: "36px",
        },
      },
    },
  },
  "& .preview_container": {
    width: "60%",
    borderRadius: "10px",
    height: "80vh",
    [theme.breakpoints.down("xl")]: {
      width: "74%",
      height: "90vh",
    },
    [theme.breakpoints.down("lg")]: {
      width: "80%",
      height: "90vh",
    },
    background: "#FFFFFF",
    "& .previwe_img_style": {
      width: "100%",
      height: "80vh",
      [theme.breakpoints.down("xl")]: {
        height: "90vh",
      },
      [theme.breakpoints.down("lg")]: {
        height: "90vh",
      },
    },
    "& .video_container": {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "0.5rem",
      "& .video_block": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
      },
    },
  },
  "& .nxt_btn_container": {
    width: "20%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: "1rem",
    [theme.breakpoints.down("xl")]: {
      width: "13%",
    },
    [theme.breakpoints.down("lg")]: {
      width: "10%",
      paddingRight: "0.2rem",
    },
    "& .btn_style": {
      height: "60px",
      [theme.breakpoints.down("xl")]: {
        height: "48px",
      },
      [theme.breakpoints.down("lg")]: {
        height: "42px",
      },
      "& svg": {
        width: "30px",
        height: "50px",
        [theme.breakpoints.down("xl")]: {
          width: "28px",
          height: "40px",
        },
        [theme.breakpoints.down("lg")]: {
          width: "28px",
          height: "36px",
        },
      }
    },
  },
}))

const PreviewImageVideo = ({ open, onClose, selectedPreview, totalAttachments, type }) => {
  const [selectedItemIndex, setSelectedItemIndex] = useState("");
  const [attachmentsLength, setAttachmentsLength] = useState("");
  
  const handleClose = () => {
    onClose();
  };

  const handleClick = (e, btn_type) => {
    e.stopPropagation();
    if (btn_type === "prev") {
      setSelectedItemIndex(selectedItemIndex === 0 ? attachmentsLength - 1 : prevIndex => prevIndex - 1);
    } else if (btn_type === "next") {
      setSelectedItemIndex(selectedItemIndex === attachmentsLength - 1 ? 0 : prevIndex => prevIndex + 1);
    }
  };

  const setIndex = () => {
    setAttachmentsLength(totalAttachments.length);
    totalAttachments.forEach((item, index) => {
      if (item?.pk === selectedPreview) {
        setSelectedItemIndex(index);
      }
    })
  };

  useEffect(() => {
    setIndex();
  }, [open]);

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      fullScreen
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      sx={{
        '& .MuiPaper-root': {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
    >
      <Container onClick={handleClose}>
        <div className="prev_btn_container">
          <IconButton
            onClick={(e) => handleClick(e, "prev")}
            sx={{
              padding: 0
            }}
          >
            <PrevIcon />
          </IconButton>
        </div>
        <div className="preview_container" onClick={(e) => e.stopPropagation()}>
          {totalAttachments.map((item, index) => {
            if (selectedItemIndex === index && type === "image") {
              return (
                <img
                  src={item?.file_urls[0]}
                  key={item?.pk}
                  alt="preview_image"
                  className="previwe_img_style"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "10px",
                  }}
                />
              )
            } else if (selectedItemIndex === index && (type === "video" || type === "reel")) {
              return (
                <div className="video_container" key={item?.pk}>
                  <video className="video_block" src={item?.file_urls[0]} type="video/mp4" controls>
                  </video>
                </div>
              )
            }
          })}
        </div>
        <div className="nxt_btn_container">
          <IconButton
            className="btn_style"
            onClick={(e) => handleClick(e, "next")}
            sx={{
              padding: 0
            }}
          >
            <NextIcon />
          </IconButton>
        </div>
      </Container>
    </Dialog>
  );
};

export default PreviewImageVideo;